<template>
    <div>
      <nice-class-type-list></nice-class-type-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  